import { BotIcon } from "lucide-react";

import { Column, Row, Text } from "@/components";

import { dates } from "@/lib/dates";
import { scheduledAgentMessages } from "@/lib/scheduledAgentMessages";
import { ScheduledAgentMessageResponse } from "@/types";

// The agent's next queued email. Sits under the thread list rather than inside
// a thread card, which would hide it whenever that thread is collapsed.
export const ScheduledAgentEmailRow = ({
  scheduledMessage,
}: {
  scheduledMessage: ScheduledAgentMessageResponse;
}) => (
  <Column className="mt-2 shrink-0 gap-1 rounded-lg border border-dashed border-blue-700 px-3 py-2">
    <Row className="items-center gap-1.5">
      <BotIcon className="h-3.5 w-3.5 shrink-0 text-primary-700" />
      <Text className="text-xs font-semibold text-slate-700">
        {scheduledAgentMessages.stepLabel(scheduledMessage)}
      </Text>
      <Text className="text-xs font-medium text-slate-500">
        · {dates.formatTime(scheduledMessage.scheduledFor)}
      </Text>
    </Row>
    <Text truncate className="text-xs font-normal text-slate-500">
      {scheduledMessage.body}
    </Text>
  </Column>
);
